/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostsempty2Inputs */

const en_aicostsempty2 = /** @type {(inputs: Aicostsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No AI calls in this period.`)
};

const de_aicostsempty2 = /** @type {(inputs: Aicostsempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In diesem Zeitraum gab es keine KI-Aufrufe.`)
};

/**
* | output |
* | --- |
* | "No AI calls in this period." |
*
* @param {Aicostsempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostsempty2 = /** @type {((inputs?: Aicostsempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostsempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostsempty2(inputs)
	return de_aicostsempty2(inputs)
});
export { aicostsempty2 as "aiCostsEmpty" }